import { render, staticRenderFns } from "./editClaimWorkFlow.vue?vue&type=template&id=23fa4470&scoped=true"
import script from "./editClaimWorkFlow.vue?vue&type=script&lang=js"
export * from "./editClaimWorkFlow.vue?vue&type=script&lang=js"
import style0 from "./editClaimWorkFlow.vue?vue&type=style&index=0&id=23fa4470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fa4470",
  null
  
)

export default component.exports